import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EvaluacionService } from 'app/services/evaluacion.service';
import { ExpedienteService } from 'app/services/expediente.service';
import { ConvocatoriaService } from 'app/services/convocatoria.service';
import { Evaluacion, Criterio, Subcriterio, PreguntaAudiencia } from 'app/models/evaluaciones/evaluacion';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { elementAt } from 'rxjs/operator/elementAt';
import { Alert } from 'selenium-webdriver';
import { Expediente } from 'app/models/expedientes/expediente';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IMultiSelectOption, IMultiSelectTexts, IMultiSelectSettings } from 'angular-2-dropdown-multiselect';
import { NUMBER_TYPE } from '@angular/compiler/src/output/output_ast';
import { ArrayObservable } from 'rxjs/observable/ArrayObservable';


@Component({
  selector: 'app-evaluacion-renovacion',
  templateUrl: './evaluacion-renovacion.component.html',
  styleUrls: ['./evaluacion-renovacion.component.scss']
})
export class EvaluacionRenovacionComponent implements OnInit {

  EvaluacionForm2: FormGroup;
  informeVisita: any;
  loadingEvaluacion: boolean;
  loadingExpediente: boolean;
  loadingresumen: boolean;
  evaluacionCompleta = false;
  audiencias_tipos: any[];
  modalRef: BsModalRef;
  formsubmitted = false;
  loadingsubmit: boolean;
  loadingvista: boolean;
  idtipoevaluacion: number;
  idevaluador: string;
  idconvocatoria: number;
  idcentro: string;
  loading: boolean;
  evaluacion: Evaluacion;
  expediente: Expediente;
  opciones: any[];
  opciones_aspectos: any[];
  opciones_resultado: any[];
  EvaluacionForm: FormGroup;
  optionsModel: number[];
  myOptions: IMultiSelectOption[];
  esTipoEvaluacionRenovacion: boolean;


  constructor(private route: ActivatedRoute, private fb: FormBuilder, private modalService: BsModalService,
    private router: Router, private evaluacionService: EvaluacionService,
    private expedienteService: ExpedienteService, private convocatoriaService: ConvocatoriaService) {
      this.loadingExpediente = true;
      this.loadingEvaluacion = true;
      this.loadingvista = false;
      this.loadingresumen = false;
      this.loadingsubmit = false;
      this.idconvocatoria = Number(this.route.snapshot.params['idconvocatoria']);
      this.idcentro = String(this.route.snapshot.params['idcentro']);
      this.idevaluador = String(this.route.snapshot.params['idevaluador']);
      this.idtipoevaluacion = Number(this.route.snapshot.params['idtipoevaluacion']);
      this.esTipoEvaluacionRenovacion = this.idtipoevaluacion === 1;
      if (!this.esTipoEvaluacionRenovacion) {
        this.loadingExpediente = false;
        this.loadingEvaluacion = false;
        return;
      }
      this.createForm();
      this.loadExpediente();
      this.loadEvaluacion();

    }

  ngOnInit() {

  }



  private loadExpediente() {
    this.expedienteService.get(this.idconvocatoria, this.idcentro).subscribe(
      data => {this.expediente = data; this.loadingExpediente = false; },
      error => {if (error.status = 401) {alert('Error de conexión con datos'); }}
    );
  }


  private loadEvaluacion() {
    this.evaluacionService.get(this.idconvocatoria, this.idcentro, this.idtipoevaluacion, this.idevaluador).subscribe(
      // tslint:disable-next-line:max-line-length
      data => {
        this.evaluacion = data;
        this.opciones = data.OPCIONES;
        this.opciones_aspectos = data.OPCIONES_ASPECTOS;
        this.opciones_resultado = data.OPCIONES_RESULTADO;
        this.audiencias_tipos = data.AUDIENCIAS;
        if (this.evaluacion.VALORES_VACIOS = 0) { this.evaluacionCompleta = true }
        this.setCriterios();
      },
      error => {if (error.status = 401) {alert('Error de conexión con datos'); }}
    );
  }

  createForm() {
    this.EvaluacionForm = this.fb.group({
      CRITERIOS: this.fb.array([
          // this.evaluacion.CRITERIOS.map(criterio => this.fb.group(criterio))
          this.initCriterios()
      ])
    });
  }






  initCriterios() {
    return this.fb.group({
      IDCRITERIO: '',
      DESCRIPCION: '',
      SUBCRITERIOS: this.fb.array([this.initSubcriterios()])
    });
  }


  initSubcriterios() {
    return this.fb.group({
      IDCRITERIO: '',
      DESCRIPCION: '',
      VALOR: new FormControl('', [Validators.required]),
      JUSTIFICACION: new FormControl('', [Validators.required]),
      DOCUMENTACION: '',
      ASPECTOS: this.fb.array([
        this.fb.group({
          IDCRITERIO: '',
          DESCRIPCION: '',
          VALOR: new FormControl('', [Validators.required])
        })
      ]),
      PREGUNTASAUDIENCIAS: this.fb.array([this.initPreguntasAudiencias()])
    });
  }


  initAspectos() {
    return this.fb.group({
      IDCRITERIO: '',
      DESCRIPCION: '',
      VALOR: new FormControl('', [Validators.required])
    });
  }


  initPreguntasAudiencias() {

    return this.fb.group({
      AUDIENCIAS: [],
      PREGUNTA: '',
    });
  }


  getpreguntasAudiencias(subcriterio: FormGroup): FormArray {
    return subcriterio.get('PREGUNTASAUDIENCIAS') as FormArray;
  };

  addPreguntaAudiencia(subcriterio: FormGroup) {
    const pregunta = subcriterio.get('PREGUNTASAUDIENCIAS') as FormArray;
    pregunta.push(this.initPreguntasAudiencias());
  }

  removePreguntaAudiencia(i: number, subcriterio: FormGroup) {
    const preguntas = subcriterio.get('PREGUNTASAUDIENCIAS') as FormArray;
    preguntas.removeAt(i);
  }





  setAudiencias(preguntaAudiencia) {
    const audienciaFGs = preguntaAudiencia.AUDIENCIAS.map(audiencia => audiencia) ;
    return audienciaFGs;
  }


  setPreguntasAudiencias(subcriterio) {
    const preguntaAudienciaFGs = subcriterio.PREGUNTASAUDIENCIAS.map(preguntaAudiencia => this.fb.group({
      PREGUNTA: preguntaAudiencia.PREGUNTA,
      AUDIENCIAS: [this.setAudiencias(preguntaAudiencia)]
    })) ;
    const preguntaAudienciaFormArray = this.fb.array(preguntaAudienciaFGs);
    return preguntaAudienciaFormArray;
  }

  setAspectos(subcriterio) {
    const aspectoFGs = subcriterio.ASPECTOS.map(aspecto => this.fb.group(aspecto)) ;
    const aspectoFormArray = this.fb.array(aspectoFGs);
    return aspectoFormArray;
  }



  setSubCriterios(criterio) {
    const subcriterioFGs = criterio.SUBCRITERIOS.map(subcriterio => this.fb.group({
      IDCRITERIO: subcriterio.IDCRITERIO,
      DESCRIPCION: subcriterio.DESCRIPCION,
      VALOR: subcriterio.VALOR,
      JUSTIFICACION: subcriterio.JUSTIFICACION,
      DOCUMENTACION: subcriterio.DOCUMENTACION,
      ASPECTOS: this.setAspectos(subcriterio),
      PREGUNTASAUDIENCIAS: this.setPreguntasAudiencias(subcriterio)
    })) ;
    const subcriteriosFormArray = this.fb.array(subcriterioFGs);
    return subcriteriosFormArray;
  }


  setCriterios() {

    const criterioFGs = this.evaluacion.CRITERIOS.map(criterio => this.fb.group({
      IDCRITERIO: criterio.IDCRITERIO,
      DESCRIPCION: criterio.DESCRIPCION,
      SUBCRITERIOS: this.setSubCriterios(criterio)
      }));

    const criteriosFormArray = this.fb.array(criterioFGs);
    this.EvaluacionForm.setControl('CRITERIOS', criteriosFormArray);
    this.loadingEvaluacion = false;
  }

  vistaPrevia() {
    this.loadingvista = true;
    this.evaluacionService.getDOCEVALUACION(this.idconvocatoria, this.idcentro, this.idtipoevaluacion, this.idevaluador, true)
    .subscribe( data => {
      const DOCEVALUACION = new Blob([data], {type: 'text/html'});
      const strURL = URL.createObjectURL(DOCEVALUACION);
      window.open(strURL);
      this.loadingvista = false;
      },
      error => {if (error.status = 401) {alert(error); }}
    );
  }



  verResumen() {
    this.loadingresumen = true;
    this.expedienteService.getDOCRESUMEN(this.idconvocatoria, this.idcentro)
    .subscribe( data => {
      const DOCEVALUACION = new Blob([data], {type: 'text/html'});
      const strURL = URL.createObjectURL(DOCEVALUACION);
      window.open(strURL);
      this.loadingresumen = false;
      },
      error => {if (error.status = 401) {alert('PROBLEMA DE CONEXIÓN. SI EL PROBLEMA PERSISTE PONGASE EN CONTACTO CON DEVA'); }}
    );
  }


  onSubmit(template) {
    this.loadingsubmit = true;
    this.formsubmitted = true;
    const operacion = '4';
        // tslint:disable-next-line:max-line-length
    this.evaluacionService.putForm(this.idconvocatoria, this.idcentro, this.idtipoevaluacion, this.idevaluador, operacion, this.EvaluacionForm.value).subscribe(
      // tslint:disable-next-line:max-line-length
      data => { this.evaluacionCompleta = data.evaluacionCompleta;  this.openModal(template); this.loadingsubmit = false; },
      error => {if (error.status = 401) {alert(error); }}
    );
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-md'});
  }





  // MULTISELEC SETTINGS
  // tslint:disable-next-line:member-ordering
  mySettings: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'checkboxes',
    buttonClasses: 'btn btn-primary bt-sm',
    itemClasses:	'pruebaselect',
    dynamicTitleMaxItems: 0,
    displayAllSelectedText: false
};

// Text configuration
// tslint:disable-next-line:member-ordering
myTexts: IMultiSelectTexts = {
    checkAll: 'Seleccionar todo',
    uncheckAll: 'deshacer selección',
    checked: 'audiencia seleccionada',
    checkedPlural: 'audiencias seleccionadas',
    searchPlaceholder: 'Buscar',
    searchEmptyResult: 'Nothing found...',
    searchNoRenderText: 'Type in search box to see results...',
    defaultTitle: 'Seleccione las audiencias',
    allSelected: 'Todas las audiencias seleccionadas',
};




verAyuda() {
  this.expedienteService.getDOCAYUDA(this.idconvocatoria, this.idcentro)
  .subscribe( data => {

    var binaryImg = atob(data);
    var length = binaryImg.length;
    var ab = new ArrayBuffer(length);
    var ua = new Uint8Array(ab);
    for (var i = 0; i < length; i++) {
        ua[i] = binaryImg.charCodeAt(i);
    }

    const DOCAYUDA = new Blob([ua], {type: 'application/pdf'});
    const strURL = URL.createObjectURL(DOCAYUDA);
    window.open(strURL);
    },
    error => {if (error.status = 401) {alert(error); }}
  );
}

verAlegaciones() {
  this.expedienteService.getDOCALEGACIONES(this.idconvocatoria, this.idcentro)
  .subscribe( data => {

    var binaryImg = atob(data);
    var length = binaryImg.length;
    var ab = new ArrayBuffer(length);
    var ua = new Uint8Array(ab);
    for (var i = 0; i < length; i++) {
        ua[i] = binaryImg.charCodeAt(i);
    }

    const DOCAYUDA = new Blob([ua], {type: 'application/pdf'});
    const strURL = URL.createObjectURL(DOCAYUDA);
    window.open(strURL);
    },
    error => {if (error.status = 401) {alert(error); }}
  );
}

verAlanceTitulos() {
  this.expedienteService.getDOCTITULOS(this.idconvocatoria, this.idcentro)
  .subscribe( data => {

    var binaryImg = atob(data);
    var length = binaryImg.length;
    var ab = new ArrayBuffer(length);
    var ua = new Uint8Array(ab);
    for (var i = 0; i < length; i++) {
        ua[i] = binaryImg.charCodeAt(i);
    }
    const DOC = new Blob([ua], {type: 'application/pdf'});
    const strURL = URL.createObjectURL(DOC);
    window.open(strURL);
    },
    error => {if (error.status = 401) {alert(error); }}
  );
}




  verDocumentacion(idtipodocumentacion) {

    this.convocatoriaService.getDOCUMENTACION(this.idconvocatoria, idtipodocumentacion)
    .subscribe( data => {

      var binaryImg = atob(data);
      var length = binaryImg.length;
      var ab = new ArrayBuffer(length);
      var ua = new Uint8Array(ab);
      for (var i = 0; i < length; i++) {
          ua[i] = binaryImg.charCodeAt(i);
      }
      let tipoDocumentacion='';

      if (idtipodocumentacion==1){ tipoDocumentacion='application/pdf'; }
      if (idtipodocumentacion==2){ tipoDocumentacion='application/msword'; }
      if (idtipodocumentacion==3){ tipoDocumentacion='application/pdf'; }



      const DOCUMENTACION = new Blob([ua], {type: tipoDocumentacion});
      const strURL = URL.createObjectURL(DOCUMENTACION);

      if(idtipodocumentacion==2){
      var link = document.createElement('a');
      link.href = strURL;
      link.download='cuestionario.doc';
      link.click();
      } else {
        window.open(strURL);
      }
      // window.open(strURL);
      },
      error => {if (error.status = 401) {alert(error); }}
    );

  }


}



// WEBPACK FOOTER //
// /app/src/app/modules/expedientes/evaluacion-renovacion/evaluacion-renovacion.component.ts